import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body, Body5, Container, Page, SvgLoadingIcon, SVG_LOADING_ICON_TYPES, Body1 } from '@ui';
import { scrollToTop } from '@utils/usefulFuncs';
import { useColorTheme } from '@hooks';
import { listTriggers } from '@services/triggers';
import { TriggerList, CreateTriggerForm } from '@features/triggers';
import { GoBackButton } from '@/ui/buttons/GoBackButton';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const pageWidth = '1400px';

function DocUploadTriggersPage() {
  const colorTheme = useColorTheme();
  const [triggers, setTriggers] = React.useState(null);
  const [listError, setListError] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const fetchTriggers = React.useCallback(async () => {
    const { triggers: nextTriggers, error } = await listTriggers();
    setTriggers(nextTriggers || []);
    setListError(error || null);
    setIsLoading(false);
  }, []);

  React.useEffect(() => {
    scrollToTop();
    fetchTriggers();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page width={pageWidth}>
          <GoBackButton />
          <Container top={48}>
            <Body1 bold>Document Upload Triggers</Body1>
            <Container top={8}>
              <Body5 isLowContrast>When documents are uploaded to a tag, these trigger actions to run</Body5>
            </Container>
            <Container top={24}>
              {isLoading ? (
                <Container top={16} row verticallyCenter>
                  <SvgLoadingIcon type={SVG_LOADING_ICON_TYPES.bars} color={colorTheme.text} />
                  <Container left={8}>
                    <Body5>Loading triggers...</Body5>
                  </Container>
                </Container>
              ) : listError ? (
                <Body5 isLowContrast>Error loading triggers. Try again.</Body5>
              ) : (
                <TriggerList triggers={triggers} onDeleted={fetchTriggers} />
              )}
            </Container>
          </Container>
        </Page>
        <Page width={pageWidth}>
          <Container top={4}>
            <Body1 bold>Create Trigger</Body1>
            <Container top={16}>
              <CreateTriggerForm onCreateSuccess={fetchTriggers} />
            </Container>
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
}

export default DocUploadTriggersPage;
